import { Theme } from '@lumapps/lumx/react';

/**
 * Returns the contrasting text color ('dark' or 'light') for a given LumApps theme.
 * Defaults to 'dark' for the light theme and 'light' for all other themes.
 */
export const calculateThemeColor = (theme: string = Theme.light) => {
    return theme !== Theme.light ? 'light' : 'dark';
};
